import { render, staticRenderFns } from "./BeardIcon.vue?vue&type=template&id=04beffb8"
import script from "./BeardIcon.vue?vue&type=script&lang=js"
export * from "./BeardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports